var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "#98A6AD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V40H50V0H0ZM2 2H48V28H37.3203L30.3203 23H24.4141L20.3281 18.9141L15.4609 19.8906L11.1562 13.4297L2 22.5859V2ZM37.5 8C35.0273 8 33 10.0273 33 12.5C33 14.9727 35.0273 17 37.5 17C39.9727 17 42 14.9727 42 12.5C42 10.0273 39.9727 8 37.5 8ZM37.5 10C38.8906 10 40 11.1094 40 12.5C40 13.8906 38.8906 15 37.5 15C36.1094 15 35 13.8906 35 12.5C35 11.1094 36.1094 10 37.5 10ZM10.8438 16.5703L14.5391 22.1094L19.6719 21.0859L23.5859 25H29.6797L36.6797 30H48V38H2V25.4141L10.8438 16.5703Z",
    fill: "#98A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookbook);
export default __webpack_public_path__ + "static/media/lookbook.515eb924051a5f2585a65a93b62c6118.svg";
export { ForwardRef as ReactComponent };